import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { CSSResultGroup, html, LitElement, TemplateResult } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { User } from 'components/ordering/multiple-baskets/basket-api/user.js'
import { BasketListItem } from 'components/ordering/multiple-baskets/basket-store/basket-list-parser.js'
import {
  BASKET_LIST_MUTATOR,
  BASKET_LIST_STORE,
  BasketListMutator,
  BasketListStore,
} from 'components/ordering/multiple-baskets/basket-store/basket-list-store.js'
import { renderDeliveryPolicyBadge } from 'components/ordering/multiple-baskets/delivery-policy.js'
import { style } from './basket-title.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'
import 'components/ordering/multiple-baskets/basket-editor/basket-editor-slide-in.js'


@customElement('csc-basket-title')
export class CSCBasketTitle extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ attribute: 'ordering-endpoint' })
  orderingEndpoint = ''

  @property({ type: Number, attribute: 'shop-id' })
  shopId = 0

  @property({ type: Number, attribute: 'party-id' })
  partyId = 0

  @property({ type: Number, attribute: 'user-id' })
  userId: number | null = null

  @property({ type: Boolean, attribute: 'readonly' })
  readonly = false

  private get user(): User {
    if (this.userId !== null && this.partyId !== null && this.shopId !== null) {
      return { userId: this.userId, shopId: this.shopId, partyId: this.partyId }
    }
    throw new Error('user-id, party-id and shop-id are mandatory.')
  }

  @state()
  private _selectedBasket: BasketListItem | null = null

  @inject(BASKET_LIST_MUTATOR)
  private basketListMutator!: BasketListMutator

  @inject(BASKET_LIST_STORE)
  private basketListStore!: BasketListStore

  protected override render(): TemplateResult {
    const hasBasketName = this._selectedBasket?.name != null
    return html`
      <div class="basket-title-container">
        <div class="large-title">
          ${hasBasketName
            ? this._selectedBasket?.name
            : t('basket_name_fallback', { ns: 'csc-basket-title', default: 'Basket' })}
        </div>
        ${renderDeliveryPolicyBadge(this._selectedBasket?.deliveryPolicy?.name || null)}
        ${this.renderBasketEditorSlideIn()}
      </div>
    `
  }

  private renderBasketEditorSlideIn(): TemplateResult {
    if (this.readonly) { return html`` }
    return html`
      <csc-basket-editor-slide-in
        class="push-right"
        ordering-endpoint="${this.orderingEndpoint}"
        shop-id="${this.shopId}"
        party-id="${this.partyId}"
        user-id="${this.userId}"
      ></csc-basket-editor-slide-in>
    `
  }

  override connectedCallback() {
    super.connectedCallback()

    createEffect(() => {
      this._selectedBasket = this.basketListStore.selectedBasket()
    })

    this.basketListMutator.initialize(this.user)
  }
}
